import security from '../../../service/security/security-services';

export interface NewComment {
    comment: string;
    error: boolean;
    destination?: Destination;
}

interface CommonControllerState {
    username: string;
    newComment: NewComment;
    showForm: boolean;
    canMarkAsError: boolean;
    showCommentCopy: boolean;
}


function resetComment(vm: CommonControllerState) {
    vm.newComment = {
        comment: '',
        error: false
    };
}

function setCommenting(vm: CommonControllerState, security: security, contract: contractService, selectedFeatures: any,
                       commentResource: string) {
    security.ensureCurrentUser().then(user => {
        vm.username = user.username;
        vm.showForm = user.hasPermission(commentResource + ':CREATE', contract.contractId);
        vm.canMarkAsError = user.hasPermission(commentResource + ':MARK_AS_ERROR', contract.contractId);
        vm.showCommentCopy = selectedFeatures && selectedFeatures.length > 0;
    })
}

function doDelete(comment: Comment, comments: Comment[], contract: contractService, onDeleteCallbacks: Function[]) {
    return contract.deleteComment(comment)
        .then(function(){
            const idx = comments.indexOf(comment);
            comments.splice(idx, 1);
            onDeleteCallbacks.forEach(function(callback){
                callback(comment);
            });
        });
}

function getComments(destination: Destination, featureTypeId: number, contract: contractService) {
    const objectId = destination + '-' + featureTypeId;
    const commentsKey = destination === 'NVDB' ? 'featureTypeComments' : 'fkbFeatureTypeComments';
    if (!contract[commentsKey][objectId]) {
        contract[commentsKey][objectId] = [];
    }
    return contract[commentsKey][objectId];
}

function FeatureCommentController($uibModalInstance: angular.ui.bootstrap.IModalInstanceService, contract: contractService, security: security,
                                  dispatcher: Dispatcher, featureType: any, feature: any, selectedFeatures: any,
                                  destination: Destination, onCommentCallbacks: Function[]){
    const vm = this;
    security.ensureCurrentUser().then(user => {
        vm.canDeleteComment = user.hasPermission('FEATURE_COMMENT:DELETE', contract.contractId);
        vm.user = user;
    })
    vm.selectedFeatures = selectedFeatures;
    const featureTypeId = featureType.id;
    const featureId = feature.id;

    setCommenting(vm, security, contract, selectedFeatures, 'FEATURE_COMMENT');

    vm.title = 'objekt av ' + destination + '-type ' + featureTypeId;

    const reset = function(savedComment: Comment){
        resetComment(vm);
        onCommentCallbacks.forEach(function(callback: Function){
            callback(savedComment);
        });
        dispatcher.signalSelectonHasChanged();
    };
    resetComment(vm);

    if (destination === 'NVDB') {
        vm.comments = contract.featureList.getFeatureById(featureId).comments;
    } else {
        vm.comments = contract.fkbFeatureList.getFeatureById(featureId).comments;
    }

    function findFeatureOnDatastore(featureIdToEdit: string) {
        return (window as any).datastore.featureTypes
            .filter(function(ft: any) {
                return ft.id === featureTypeId;
            })[0].features
            .filter(function(f: any) {
                return f.id === featureIdToEdit;
            });
    }

    vm.addComment = function(){
        const comment = vm.newComment;
        if (comment.comment.length > 0) {
            const dontCopy = !vm.newComment.copyToFeatureIds;
            const featuresToModify = (vm.selectedFeatures.length <= 0 || dontCopy) ? [featureId] : selectedFeatures.map(function(f: any){return f.id; });
            if (!featuresToModify.includes(featureId)) {
                featuresToModify.push(featureId);
            }
            featuresToModify.forEach(function(f: any) {
                contract.saveFeatureComment({featureId: f, destination, comment: comment.comment, error: comment.error})
                    .then(function(comment){
                                                findFeatureOnDatastore(f)
                            .forEach(function(f: any) {
                                f.comments.push(comment);
                                if (comment.error) {
                                    const issue = {message: comment.comment, severity: 'ERROR', code: 'ISSUE_ADDED_BY_OPERATOR', location: {commentId: comment.id}};
                                    f.errors.push(issue);
                                }
                            });
                                                return comment;
                    })
                    .then(reset);
            });
        }
    };

    vm.delete = function(comment: Comment) {
        doDelete(comment, vm.comments, contract, onCommentCallbacks)
            .then(function(){
                findFeatureOnDatastore(featureId)
                    .forEach(function(f: any) {
                        const idx = f.comments.indexOf(comment);
                        f.comments.splice(idx, 1);
                        if (comment.error) {
                            f.errors = f.errors.filter(function(error: any){
                                return error.location.commentId !== comment.id;
                            });
                        }
                    });
                dispatcher.signalSelectonHasChanged();
            });
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}

function FeatureTypeCommentController($uibModalInstance: angular.ui.bootstrap.IModalInstanceService, contract: contractService, security: security,
                                      dispatcher: Dispatcher, featureTypeId: number, destination: Destination,
                                      onCommentCallbacks: Function[]){
    const vm = this;
    security.ensureCurrentUser().then(user => {
        vm.user = user;
        vm.canDeleteComment = user.hasPermission('FEATURE_TYPE_COMMENT:DELETE', contract.contractId);
    })

    vm.title = destination + '-type ' + featureTypeId;

    resetComment(vm);
    setCommenting(vm, security, contract, undefined, 'FEATURE_TYPE_COMMENT');

    const reset = function(savedComment: Comment){
        resetComment(vm);
        onCommentCallbacks.forEach(function(callback){
            callback(savedComment);
        });
        dispatcher.signalSelectonHasChanged();
    };

    vm.comments = getComments(destination, featureTypeId, contract);


    vm.addComment = function(){
        const comment = vm.newComment;
        if (comment.comment.length > 0) {
            contract.saveFeatureTypeComment({featureTypeId, comment: comment.comment, destination: destination || 'NVDB', error: comment.error})
                .then(function(comment){
                    (window as any).datastore.featureTypes
                        .filter(function(ft: any){
                            return ft.id === featureTypeId;
                        })
                        .forEach(function(ft: any){
                            ft.comments.push(comment);
                        });
                    return comment;
                })
                .then(reset);
        }
    };

    vm.delete = function(comment: Comment) {
        doDelete(comment, vm.comments, contract, onCommentCallbacks)
            .then(function(){
                (window as any).datastore.featureTypes
                    .filter(function(ft: any){
                        return ft.id === featureTypeId;
                    })
                    .forEach(function(ft: any){
                        const idx = ft.comments.indexOf(comment);
                        ft.comments.splice(idx, 1);
                    });
                dispatcher.signalSelectonHasChanged();
            });
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}

function ContractCommentController($uibModalInstance: angular.ui.bootstrap.IModalInstanceService, contract: contractService, security: security){
    const vm = this;
    security.ensureCurrentUser().then(user => {
        vm.user = user;
        vm.canDeleteComment = user.hasPermission('CONTRACT_COMMENT:DELETE', contract.contractId);
    });

    vm.comments = contract.comments;

    vm.title = 'Kontrakt ' + contract.name;

    resetComment(vm);
    setCommenting(vm, security, contract, undefined, 'CONTRACT_COMMENT');

    const reset = function(){
        resetComment(vm);
    };

    vm.addComment = function(){
        const comment: NewComment = vm.newComment;
        if (comment.comment.length > 0) {
            contract.createContractComment(comment, comment.error)
                .then(reset);
        }
    };

    vm.delete = function(commment: Comment) {
        doDelete(commment, vm.comments, contract, []);
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}

function StatusFeatureTypeCommentController($uibModalInstance: angular.ui.bootstrap.IModalInstanceService, contract: contractService, security: security,
                                            featureTypeId: number, featureTypeName: string, destination: Destination,
                                            onCommentCallbacks: Function[]){
    const vm = this;
    security.ensureCurrentUser().then(user => {
        vm.user = user;
        vm.canDeleteComment = user.hasPermission('FEATURE_TYPE_COMMENT:DELETE', contract.contractId);
    })
    vm.comments = contract.comments;
    vm.title = featureTypeName + ' (' + destination + ')';

    resetComment(vm);
    setCommenting(vm, security, contract, undefined, 'FEATURE_TYPE_COMMENT');

    const reset = function(savedComment: Comment){
        resetComment(vm);
        onCommentCallbacks.forEach(function(callback){
            callback(savedComment);
        });
    };

    vm.comments = getComments(destination, featureTypeId, contract);


    vm.addComment = function(){
        const comment = vm.newComment;
        if (comment.comment.length > 0) {
            contract.saveFeatureTypeComment({featureTypeId, comment: comment.comment, destination, error: comment.error})
                .then(reset);
        }
    };

    vm.delete = function(commment: Comment) {
        doDelete(commment, vm.comments, contract, onCommentCallbacks);
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}

FeatureCommentController.$inject = ['$uibModalInstance', 'contract', 'security', 'dispatcher', 'featureType', 'feature', 'selectedFeatures', 'destination', 'onCommentCallbacks'];
FeatureTypeCommentController.$inject = ['$uibModalInstance', 'contract', 'security', 'dispatcher', 'featureTypeId', 'destination', 'onCommentCallbacks'];
ContractCommentController.$inject = ['$uibModalInstance', 'contract', 'security'];
StatusFeatureTypeCommentController.$inject = ['$uibModalInstance', 'contract', 'security', 'featureTypeId', 'featureTypeName', 'destination', 'onCommentCallbacks'];

import * as angular from 'angular';
import contractService from '../../../service/contract/contract-services';
import {Comment, Destination} from "../../../integration/representation/contract";
import {Dispatcher} from "../contract-status/contract-status-modal-controllers";
export default angular.module('dataforvalter.comments-modal', ['dataforvalter.contract'])
    .controller('FeatureCommentController', FeatureCommentController)
    .controller('FeatureTypeCommentController', FeatureTypeCommentController)
    .controller('ContractCommentController', ContractCommentController)
    .controller('StatusFeatureTypeCommentController', StatusFeatureTypeCommentController)
    .name;
